import React from "react";
import WithSubscribe from "./Hero/WithSubscribe";
import Features from "./Features";
import Advantages from "./Advantages";
import LatestBlogs from "./LatestBlogs";
import Contact from "./Contact";
import WithAnalyze from "./Hero/WithAnalyze";

const HomePage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get("variant");

    const isVariantA = variantParam
        ? variantParam.toLowerCase() === "a"
        : Math.random() < 0.5;

    return (
        <div>
            {isVariantA ? <WithSubscribe/> : <WithAnalyze/>}
            <Features></Features>
            <Advantages></Advantages>
            <LatestBlogs></LatestBlogs>
            <Contact></Contact>
        </div>
    )
        ;
};

export default HomePage;
